import { format } from "date-fns";

export const generateInternalSummary = (pkg) => {
  const contractor = pkg?.contractor?.businessName || "Unknown Contractor";
  const address = pkg?.project_address || "Unknown Address";
  const owner = pkg?.property_owner?.name || "Unknown Owner";
  const createdAt = pkg?.permit_package_added_at
    ? format(new Date(pkg.permit_package_added_at * 1000), "MMMM dd, yyyy")
    : "Unknown Date";

  const docCount = pkg?.selected_documents?.length || 0;

  const cityPermit = pkg?.city_scraper?.permit_number;
  const cityPermitCreatedAt = pkg?.city_scraper?.created_at
    ? format(new Date(pkg.city_scraper.created_at * 1000), "MMMM dd, yyyy")
    : null;
  const noc = pkg?.documents?.noc;
  const nocCreatedAt = format(
    new Date(noc?.created_at * 1000),
    "MMMM dd, yyyy"
  );

  let cityStatus = "";
  let nocStatus = "";
  let docStatus = "";
  let processingPermitEmpty =
    Object.keys(pkg?.processing_permit).length === 0 || !pkg?.processing_permit;
  let notaryStarted = "";

  if (noc?.is_created) {
    nocStatus = `The NOC was created on ${nocCreatedAt} and the creation time was ${noc?.creation_time} seconds.`;
  } else if (
    noc?.is_created === false &&
    ["pending", "failed"].includes(noc?.status?.lower())
  ) {
    nocStatus = `The NOC was not created, and it is currently ${noc?.status}.`;
  } else {
    nocStatus = `The NOC is not started yet.`;
  }
  if (processingPermitEmpty) {
    notaryStarted = `The notarization process has not started yet.`;
  }
  if (cityPermit) {
    const cityFilled = pkg?.city_scraper?.info_filled;
    const docUploaded = pkg?.city_scraper?.doc_uploaded;

    const fillStatus = cityFilled
      ? "The required fields on the city website were automatically filled"
      : "The fields on the city website have not been filled";

    const uploadStatus = docUploaded
      ? "and the documents have been uploaded"
      : "and the documents have not yet been uploaded";

    cityStatus = ` The system was connected to the Jacksonville city website, and a permit number (${cityPermit}) was generated on ${cityPermitCreatedAt}. ${fillStatus} ${uploadStatus}.`;
  }

  const notarization = pkg?.processing_permit?.notarization?.owner || {};
  const hasSigned = notarization?.is_signed ? "has" : "has not";
  const notarizedStatus = notarization?.is_notarized ? "completed" : "pending";
  const recordedStatus = pkg?.recorded
    ? "already recorded"
    : "not yet recorded";

  return `${contractor} initiated this permit package for ${address}.${cityStatus} The Package includes ${docCount} document(s). It was initiated on ${createdAt}. ${nocStatus} The owner, ${owner}, ${hasSigned} signed the documents. Notarization is ${notarizedStatus}, and the package is ${recordedStatus}.`;
};

export const generateExternalSummary = (pkg) => {
  const contractorFirst = pkg?.contractor?.PERSON?.first_name || "";
  const contractorLast = pkg?.contractor?.PERSON?.last_name || "";
  const contractor =
    `${contractorFirst} ${contractorLast}`.trim() || "Unknown Contractor";

  const address = pkg?.document_location?.project_address || "Unknown Address";
  const owner = pkg?.signer?.name || "the property owner";

  let createdAt = "Unknown Date";
  if (pkg?.created_at) {
    try {
      createdAt = format(new Date(pkg.created_at), "MMMM dd, yyyy");
    } catch {
      createdAt = "Invalid Date";
    }
  }

  const notarized = pkg?.notarized;
  const recorded = pkg?.recorded;

  const notarizedStatus = notarized ? "completed" : "pending";
  const recordedStatus = recorded ? "completed" : "pending";
  const actionNeeded = notarized
    ? "no further action required"
    : "sign and notarize the document";

  return `This Notice of Commencement was externally uploaded by ${contractor} for the property at ${address}. The owner, ${owner}, is required to ${actionNeeded}. Notarization is ${notarizedStatus}, and recording is ${recordedStatus}. The package was submitted on ${createdAt}.`;
};
